import get from 'lodash/get';
import REPVISITS_LOCATION_TYPE from '../../utils/repvisits-location-types';

const PENDING = 'PENDING';
const FAIR = 'CollegeFair';
const VISIT = 'RepVisitsAppointment';

export function getDate(date, time) {
  const dateParts = (date || '').split('-');
  const timeParts = (time || '').split(':');
  return new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], timeParts[0], timeParts[1]);
}

function createCalEvent(event, enabledFeatures = []) {
  const { date, startISOTime, endISOTime, id,
    userBookingStatus, collegeFairId, highSchool, dayId, appointmentId, timezone, chosenVisitLocationType } = event;
  let eventType = (collegeFairId) ? FAIR : undefined;
  eventType = (dayId) ? VISIT : eventType;
  const pendingStatus = userBookingStatus === PENDING;

  const title = get(event, 'highSchool.name');
  const allDay = !startISOTime || !endISOTime;

  let type;
  if (eventType === FAIR) {
    type = 'fair';
  } else if (
    eventType === VISIT && chosenVisitLocationType === REPVISITS_LOCATION_TYPE.VIRTUAL
  ) {
    type = 'virtual';
  } else if (
    eventType === VISIT && chosenVisitLocationType !== REPVISITS_LOCATION_TYPE.VIRTUAL
  ) {
    type = 'visit'; // required, looks like is used by the AMEGO stuff
  } else {
    type = 'personal';
  }

  return {
    start: getDate(date, startISOTime),
    end: getDate(date, endISOTime),
    id,
    collegeFairId,
    highSchool,
    dayId,
    allDay,
    title,
    type,
    appointmentId,
    pendingStatus,
    timezone,
  };
}

export default function generateEvents(events, enabledFeatures = []) {
  return events.map((event) => createCalEvent(event, enabledFeatures));
}
